export const SUCCESS_OTHER_PROPERTY_DETAILS="SUCCESS_OTHER_PROPERTY_DETAILS";
export const FAILED_OTHER_PROPERTY_DETAILS="FAILED_OTHER_PROPERTY_DETAILS";
export const REQUST_OTHER_PROPERTY_DETAILS="REQUST_OTHER_PROPERTY_DETAILS";
